            
<template>


    <div class="size1 bg0 where1-parent">
        <div class="size3 flex-col-sb flex-w p-l-50  p-b-45 respon1 reponsive-celular">
            <center>
                <img src="@/assets/logo-seplag.png" class="icon-login">
                <p class="texto-sistema">Recadastramento 2024</p>
                <p class="m1-txt1">Atualização cadastral periódica dos servidores e empregados públicos do Estado de
                    Mato Grosso</p>
                <br>
            </center>
            <div class="p-b-10 p-t-5">
                <form ref="formRef" class="p-grid p-fluid">
                    <div class="wrap-input100 m-b-10 validate-input" data-validate="Name is required">
                        <input class="s2-txt1 placeholder0 input100" type="text" id="login" name='email'
                            placeholder="Usuário" v-model="user.login">
                        <span class="focus-input100"></span>
                    </div>
                    <div class="wrap-input100 m-b-20 validate-input" data-validate="Email is required: ex@abc.xyz">

                        <div class="input-eyes">
                            <input class="s2-txt1 placeholder0 input100" :type="showPassword ? 'text' : 'password'"
                                id="senha" name='password' v-model="user.senha" placeholder="Senha"
                                v-on:keyup.enter="logar()" />
                            <button type="button"
                                :class="['input-button', 'pi', showPassword ? 'pi-eye-slash' : 'pi-eye']"
                                @click="(e) => { e.preventDefault(); showPassword = !showPassword }" />
                        </div>
                        <span class="focus-input100"></span>

                    </div>
                    <div class="w-full">
                        <button class="flex-c-m s2-txt2 size4 bg1 bor1 hov1 trans-04" type="button" @click="logar()">
                            Fazer Login
                        </button>
                    </div>
                </form>
                <div class="p-grid p-fluid">
                    <p class=" p-col-6 s2-txt3 p-t-18" style="cursor:pointer" @click="resetarSenha()">
                        Esqueci a minha senha
                    </p>
                    <p class="p-col-6 p-md-4 p-md-offset-2 s2-txt3 p-t-18" style="cursor:pointer;text-align: right;"
                        @click="obterInfAcesso()">
                        Informações
                    </p>
                </div>
            </div>
            <div class="p-col-12">
                <img src="@/assets/apoio-sti.png" class="img-footer-phone">
            </div>
        </div>

        <div class="flex-c-m bg-img1 size2 where1 overlay1 where2 respon2 display" style="">
            <!-- <div class="wsize2 flex-w flex-c-m cd100 js-tilt" style="will-change: transform; transform: perspective(300px) rotateX(0deg) rotateY(0deg);">
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('decreto')">
                    <span class="l2-txt1 p-b-9 days"><i class="pi pi-file-o"></i></span>
                    <span class="s2-txt4">Decreto de<br>Monitoramento</span>
                </div>
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('manuais')">
                    <span class="l2-txt1 p-b-9 hours"><i class="pi pi-copy"></i></span>
                    <span class="s2-txt4">Manuais e<br>Autocapacitação</span>
                </div>
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('perguntas')">
                    <span class="l2-txt1 p-b-9 minutes"><i class="pi pi-question"></i></span>
                    <span class="s2-txt4">Perguntas<br>Frequentes</span>
                </div>
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('treinamento')">
                    <span class="l2-txt1 p-b-9 seconds"><i class="pi pi-align-center"></i></span>
                    <span class="s2-txt4">Lista de<br>Treinamento</span>
                </div>
            </div> -->
        </div>

        <!-- MODAL FAQ -->
        <Dialog header=' ' class="cadastro-rapido-seplag" :visible.sync="exibirTelaInstrucao"
            :contentStyle="{ width: '45vw' }" :modal="true" v-if="exibirTelaInstrucao">
            <div class="p-col-12">
                <p style="font-size:14px;text-align: center; font-weight: bold;"> Bem-vindo(a) ao Recadastramento 2024!
                </p>
                <br>
                <p style="font-size:14px;text-align: justify;">
                    <i class="pi pi-check"></i> Manual de uso: <a
                        href="http://201.49.166.151/pydio/data/public/recadastramento" class="p-button-link btnLink"
                        target='_blank'>Documento</a>
                </p>
                <p style="font-size:14px;text-align: justify;margin-bottom: 8px;"> <i class="pi pi-check"></i> Para
                    acessar o Recadastramento 2024: </p>
                <ul style="margin-left:1vw; margin-bottom: 8px;">
                    <li> <i class="pi pi-circle-on" style="fontSize: 0.5rem;"></i> Servidor público: “usuário”:
                        matrícula funcional e senha, mesma utilizada para acessar o Portal do Servidor.</li>
                    <li> <i class="pi pi-circle-on" style="fontSize: 0.5rem;"></i> Caso não possua usuário e senha,
                        clique na opção ESQUECI MINHA SENHA para ativar.</li>
                    <li> <i class="pi pi-circle-on" style="fontSize: 0.5rem;"></i> Empregado público: “usuário”: CPF.
                    </li>
                </ul>
                <!-- #22338 Trocar a informação em destaque -->
                <p style="font-size:14px;text-align: justify;margin-bottom: 8px;">
                    <i class="pi pi-check"></i> O recadastramento é obrigatório aos servidores públicos ativos da 
                    Administração Pública Direta e Indireta do Poder Executivo do Estado de Mato Grosso. 
                    Incluem os ocupantes de cargos públicos efetivos civis, os exclusivamente comissionados, 
                    os requisitados, cedidos, permutados, afastados ou licenciados, os militares, empregados públicos,
                    contratados temporários, residentes técnicos e estagiários.
                </p>

                <p style="font-size:14px;text-align: justify;margin-bottom: 8px;">
                    <i class="pi pi-check"></i> Ficam dispensados do recadastramento relativo ao ano de 2024, os
                    servidores que ingressarem a partir da data de início do recadastramento, os aposentados e os
                    pensionistas.
                </p>

                <p style="font-size:14px;text-align: justify;;margin-bottom: 8px;">
                    <i class="pi pi-check"></i> O recadastramento de aposentados e pensionistas é de responsabilidade do
                    Mato Grosso Previdência – MT PREV.
                </p>

                <!-- <div style="margin-top:15px">
                    <div style="width:140px">
                        <p style="font-size:14px;text-align: justify;margin-bottom:8px;background-color: #f7f014">
                            <strong>ATENÇÃO SERVIDOR</strong>
                        </p>
                    </div>

                    <p style="font-size:14px;text-align: justify;margin-bottom: 8px;">
                        Conforme normas estabelecidas na Instrução Normativa nº 11/2022/SEPLAG (acesse link <a
                            href="https://www.iomat.mt.gov.br/portal/visualizacoes/html/16556/#e:16556/#m:1296510"
                            class="p-button-link btnLink" target="_blank">IN 11/2022</a>)
                    </p>

                    <p style="font-size:14px;text-align: justify;margin-bottom: 8px;">
                        Para regularização do recadastramento 2022, realizar os seguintes procedimentos da Seção V, Art.
                        12
                    </p>

                    <p style="font-size:14px;text-align: justify;margin-bottom: 8px;">
                        Enviar os Documentos necessários para regularização:
                    </p>

                    <ul style="margin-left:1vw; margin-bottom: 8px;">
                        <li style="margin-bottom:5px"> 1 - Requerimento padrão preenchido (ou documento com
                            justificativa para regularização);</li>
                        <li> 2 - Documento de identificação com foto;</li>
                        <li> 3 - Protocolo de finalização do Recadastramento 2022;</li>
                        <li> 4 - 3 últimas folhas de frequência (ou documento equivalente), ou publicação no Diário
                            Oficial do afastamento;</li>
                    </ul>
                    <p style="font-size:14px;text-align: justify;margin-bottom: 8px;">
                        Devem ser enviados por e-mail para <strong>processorecadastramento@seplag.mt.gov.br</strong> ou
                        via <strong>SIGADOC </strong>.
                    </p>
                </div> -->

            </div>
            <template #footer>
                <Button :label="'ok'" icon="pi pi-check" @click="fecharTelaInstrucao" class="p-button-success" />
            </template>
        </Dialog>

        <!-- MODAL ESQUECI A MINHA SEENHA -->
        <cadastro-rapido tituloTela="Esqueci a minha senha" v-model="exibirTelaSenha" :modoEdicao="modoEdicao"
            :onEnviarLinkAtivacao="alterarRegistro">
            <div class="p-col-12">
                <Rotulo nome="Usuário" cols="12">
                    <InputText type="text" v-model="registro.matricula" v-required />
                </Rotulo>
                <Rotulo nome="CPF" cols="12">
                    <InputMask mask="999.999.999-99" type="text" v-model="registro.cpf" v-required />
                </Rotulo>
                <Rotulo nome="Data Nascimento" cols="12">
                    <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="registro.dataNascimento"
                        v-required />
                </Rotulo>
            </div>
        </cadastro-rapido>

        <!-- MODAL DOCUMENTOS -->
        <cadastro-rapido :tituloTela="tituloTabelaDocumento" tamanhoTela="450" v-model="exibirTelaDocumentos">
            <div class="p-col-12">
                <DataTable :value="documentos">
                    <Column field="nomeDocumento">
                    </Column>
                    <Column headerStyle="width: 6em" bodyStyle="text-align: center">
                        <template #body="slotProps">
                            <Button type="button" icon="pi pi-download" class="p-button-success"
                                style="margin-right: .5em"> Visualizar</Button>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </cadastro-rapido>

        <!-- MODAL CONFIRMA ALTERAR SENHA -->
        <Dialog header="Confirmação" :visible.sync="exibirModalConfirmacaoSenha" :style="{ width: '24em' }" :modal="true">
            <div class="confirmation-content" :style="{ color: colorMenssagemConfirmacao }">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2em"
                    v-if="colorMenssagemConfirmacao != '#07631e'" />
                <span style="text-align: justify;">{{ mensagemConfirmacao }}</span>
            </div>
            <template #footer>
                <Button label="Fechar" icon="pi pi-times" @click="fecharConfirmacao" class="p-button-text" />
            </template>
        </Dialog>

    </div>


</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import Rotulo from '@/template/RotuloSeplag.vue'
import CadastroRapido from '@/template/CadRapidoSeplag.vue'
import { baseApiUrl } from '@/config/global'

const getDefaultState = () => {
    return {
        matricula: '',
        email: ''
    }
}

export default {
    name: 'Login',
    computed: mapGetters(['isUserLogado']),
    components: { Rotulo, CadastroRapido },
    modoEdicao: 'logar',

    mounted() {
        this.urlLogin = window.location.origin + "/recadastramento"
        var count = Object.keys(this.$route.query).length
        if (count > 0) {
            this.codigoUrl = this.$route.query.codigo
            this.validarNovaSenha()
        } else {
            this.exibirTelaInstrucao = true
        }
    },
    data: function () {
        return {
            showPassword: false,
            user: {
                login: '',
                senha: '',
                identificacao: '',
                vue: this
            },

            registro: getDefaultState(),
            codigoUrl: null,
            mensagemConfirmacao: null,
            colorMenssagemConfirmacao: '#07631e',
            exibirTelaDocumentos: false,
            exibirModalConfirmacaoSenha: false,
            modoEdicao: 'alterar',
            urlLogin: null,
            tiposUsuario: [
                { flgTipo: "S", descTipo: "Servidor" },
                { flgTipo: "A", descTipo: "Aposentado" },
                { flgTipo: "P", descTipo: "Pensionista" }
            ],
            tiposLogin: [
                { flgTipo: "S", descTipo: "Servidor ou Aposentado" },
                { flgTipo: "P", descTipo: "Pensionista" }
            ],
            colunasTabelaDocumentos: [{ nomeDocumento: null }],
            documentos: [{ nomeDocumento: null }],
            tituloTabelaDocumento: "",
            selectedTipoLogin: { 'flgTipo': "S", 'descTipo': "Servidor ou Aposentado" },
            exibirTelaSenha: false,
            apiUrlRecursoBuscarServidor: 'publicos/iniciaregistroservidor',
            apiUrlRecursoBuscarEmpregador: 'publicos/iniciaregistroempregado',
            exibirTelaInstrucao: false
        }
    },
    methods: {
        ...mapActions(['logarUsuario']),
        listarDocumentos(tipoDocumento) {
            this.exibirTelaSenha = false,
                this.exibirTelaDocumentos = true

            if (tipoDocumento == "decreto") {
                this.tituloTabelaDocumento = "Decreto de Monitoramento"
                this.documentos = [{
                    "nomeDocumento": "Decreto n.º XXXX de XXXX"
                }]
            } else if (tipoDocumento == "manuais") {
                this.tituloTabelaDocumento = "Manuais e Autocapacitação"
                this.documentos = [
                    { "nomeDocumento": "Manual" },
                    { "nomeDocumento": "Apresentação do Monitoramento" },
                    { "nomeDocumento": "Autocapacitação" }
                ]
            } else if (tipoDocumento == "perguntas") {
                this.tituloTabelaDocumento = "Perguntas Frequentes"
                this.documentos = [{
                    "nomeDocumento": "Perguntas Frequentes"
                }]
            } else if (tipoDocumento == "treinamento") {
                this.tituloTabelaDocumento = "Lista de Treinamento"
                this.documentos = [{
                    "nomeDocumento": "Lista de Treinamento"
                }]
            }
        },
        resetarSenha() {

            this.exibirTelaSenha = true,
                this.exibirTelaDocumentos = false
            this.modoEdicao = 'enviaremailativacao'
        },
        obterInfAcesso() {
            this.exibirTelaSenha = false,
                this.exibirTelaInstrucao = true
        },
        async logar() {
            if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != 'false') {
                this.$store.commit("setLoader", true)
                await this.$recaptchaLoaded()
                const token = await this.$recaptcha('login')
                if (token) {
                    this.$store.commit("setTokenrecaptcha", token)
                    let res = await this.logarUsuario(this.user)
                    if (res) {
                        this.$store.commit("setUserLogado", true)
                    }
                } else {
                    this.$store.commit("setLoader", false)
                    this.$toast.add({ severity: 'error', summary: "Erro ao validar o recaptcha, por favor recarregue a pagina e tente novamente", life: 15000 })
                }
            } else {
                let res = await this.logarUsuario(this.user)
                if (res) {
                    this.$store.commit("setUserLogado", true)
                }

            }
            this.limparSessao()
        },
        validarNovaSenha() {
            var objValida = {
                codigoValidacao: this.codigoUrl,
                pathAplicacao: this.urlLogin,
                nomeSistema: process.env.VUE_APP_TITLE,
                assinaturaEmail: "COORDENADORIA DE MONITORAMENTO DE PESSOAL"
            }
            if (this.exibirTelaInstrucao) {
                this.exibirTelaInstrucao = false
            }
            this.$http.post(`${baseApiUrl}/publicos/esquecisenha/novasenha`, JSON.stringify(objValida))
                .then(res => {
                    this.mensagemConfirmacao = res.data.mensagem
                    this.colorMenssagemConfirmacao = "#07631e"
                    this.exibirModalConfirmacaoSenha = true
                })
            // .catch(error => {
            //     this.mensagemConfirmacao = error.response.data[0].msgUsuario
            //     this.colorMenssagemConfirmacao = "#bf1b1b"
            //     this.exibirModalConfirmacaoSenha = true
            // })

        },
        alterarRegistro() {
            var dadosForm = {
                login: this.registro.matricula,
                cpf: this.registro.cpf,
                dataNascimento: this.registro.dataNascimento,
                pathAplicacao: this.urlLogin,
                nomeSistema: process.env.VUE_APP_TITLE,
                assinaturaEmail: "COORDENADORIA DE MONITORAMENTO DE PESSOAL"
            }
            this.$http.post(`${baseApiUrl}/publicos/esquecisenha`, JSON.stringify(dadosForm))
                .then(res => {
                    this.exibirTelaSenha = false,
                        this.$toast.add({ severity: 'success', summary: res.data.mensagem, life: 9000 })
                }).catch(() => {
                    this.exibirTelaSenha = false
                })
        },
        fecharConfirmacao() {
            this.exibirModalConfirmacaoSenha = false
        },

        fecharTelaInstrucao() {
            this.exibirTelaInstrucao = !this.exibirTelaInstrucao
        },
        limparSessao(){
            localStorage.clear();
    }
    },
    created() {

    }

}
</script>

<style scoped>
.bg1 {
    background-color: #007ad9;
}

.wrap-pic1 {
    width: 70%;
}

.bg-img1 {
    background-image: url('../../assets/bg_login.png');
}

.texto-sistema {
    font-size: 30px;
    color: #005494;
    font-weight: bold;
    padding: 0;
    margin: 0;

}

.icon-login {
    width: 80%;
    margin-top: 4vw;
    margin-bottom: 3vw;
    margin-left: -2.2vw;
}

.img-top-phone {
    width: 90%;
    margin-top: 12vw;
    margin-left: -6vw;

}

.img-footer-phone {
    width: 12vw;
    margin-left: 8vw;
    margin-top: 4vw;
}

.m1-txt1 {
    font-size: 15px;
}

.s2-txt4 {
    text-transform: none;
    font-family: "Open Sans", "Helvetica Neue", sans-serif;
    font-size: 15px;
}

.bor2 {
    text-align: center;
    cursor: pointer;
}

.confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
}

.btnLink {
    padding: 0;
    color: blue;
}

.btnLink:hover {
    color: #007ad9;
    text-decoration: underline;
}

@media screen and (max-width: 40em) {
    .display {
        display: none !important;
    }

    .reponsive-celular {
        padding-right: 26px !important;
        padding-left: 18px !important;
    }

    .wrap-pic1 {
        width: 100%;
    }

    .img-footer-phone {
        width: 37vw;
        margin-left: 25vw;
        margin-top: 25vw;
    }

    .cadastro-rapido-seplag {
        width: 100% !important;
    }

    .p-dialog-content {
        width: 100% !important;
        word-wrap: break-word;
    }
}

@media screen and (max-width: 62em) and (min-width: 40em) {

    .display {
        display: none !important;
    }

    .reponsive-celular {
        padding-right: 26px !important;
        padding-left: 18px !important;
    }

    .wrap-pic1 {
        width: 100%;
    }

    .img-footer-phone {
        width: 37vw;
        margin-left: 10vw;
        margin-top: 11vw;
    }
}

.input-eyes {
    position: relative;
    flex: 1 0%;
    display: flex;
    height: 100%;
    align-items: center;
}

.input-button {
    position: absolute;
    display: block;
    right: 16px;
    font-size: 1.3rem;
}
</style>